import { PROCESSING_VALIDATE_USER_REGISTRATION, FINISHED_VALIDATE_USER_REGISTRATION } from '../actions/kycActions';
import { PROCESSING_SET_USER_CONFIG, FINISHED_SET_USER_CONFIG } from '../actions/kycManualActions';
import { PROCESSING_VERIFY_EMAIL, FINISHED_VERIFY_EMAIL } from '../actions/verifyEmailActions';
import { PROCESSING_RESET_PASSWORD, FINISHED_RESET_PASSWORD } from '../actions/resetPasswordActions';
import { PROCESSING_CONFIRM_WITHDRAW, FINISHED_CONFIRM_WITHDRAW, FINISHED_VERIFY_ADDRESS, PROCESSING_VERIFY_ADDRESS, PROCESSING_VERIFY_DEVICE, FINISHED_VERIFY_DEVICE } from '../actions/confirmWithdrawActions';
var initialState = {
  processingValidateUserRegistration: false,
  processingSetUserConfig: false,
  processingVerifyEmail: false,
  processingResetPassword: false,
  processingConfirmWithdraw: false,
  processingVerifyAddress: false,
  processingVerifyDevice: false
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type;
  switch (type) {
    case PROCESSING_VERIFY_ADDRESS:
      return Object.assign({}, state, {
        processingVerifyAddress: true
      });
    case FINISHED_VERIFY_ADDRESS:
      return Object.assign({}, state, {
        processingVerifyAddress: false
      });
    case PROCESSING_VALIDATE_USER_REGISTRATION:
      return Object.assign({}, state, {
        processingValidateUserRegistration: true
      });
    case FINISHED_VALIDATE_USER_REGISTRATION:
      return Object.assign({}, state, {
        processingValidateUserRegistration: false
      });
    case PROCESSING_SET_USER_CONFIG:
      return Object.assign({}, state, {
        processingSetUserConfig: true
      });
    case FINISHED_SET_USER_CONFIG:
      return Object.assign({}, state, {
        processingSetUserConfig: false
      });
    case PROCESSING_VERIFY_EMAIL:
      return Object.assign({}, state, {
        processingVerifyEmail: true
      });
    case FINISHED_VERIFY_EMAIL:
      return Object.assign({}, state, {
        processingVerifyEmail: false
      });
    case PROCESSING_RESET_PASSWORD:
      return Object.assign({}, state, {
        processingResetPassword: true
      });
    case FINISHED_RESET_PASSWORD:
      return Object.assign({}, state, {
        processingResetPassword: false
      });
    case PROCESSING_CONFIRM_WITHDRAW:
      return Object.assign({}, state, {
        processingConfirmWithdraw: true
      });
    case FINISHED_CONFIRM_WITHDRAW:
      return Object.assign({}, state, {
        processingConfirmWithdraw: false
      });
    case PROCESSING_VERIFY_DEVICE:
      return Object.assign({}, state, {
        processingVerifyDevice: true
      });
    case FINISHED_VERIFY_DEVICE:
      return Object.assign({}, state, {
        processingVerifyDevice: false
      });
    default:
      return state;
  }
}